var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PHeader'),_c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"fof"},[_c('p',[_vm._v(_vm._s(_vm.$t("pageNotFound")))]),_c('h1',[_vm._v(_vm._s(_vm.$t("error404")))])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }